/**
 * Lightweight logger that silences debug/info/log in production while keeping
 * warn/error active everywhere. Dev (NODE_ENV !== "production") passes calls
 * straight through to the native console.
 *
 * Why .bind(console)?  It preserves the original call site (file:line) in the
 * browser DevTools instead of every log appearing to come from logger.js.
 *
 * Escape hatch: set REACT_APP_LOG_VERBOSE=true at build time to keep debug/info
 * active in a production build (useful for short-lived debug deploys).
 */

const isDev = process.env.NODE_ENV !== "production";
const isVerbose = process.env.REACT_APP_LOG_VERBOSE === "true";
const verboseEnabled = isDev || isVerbose;

const noop = () => {};

const logger = {
  debug: verboseEnabled ? console.debug.bind(console) : noop,
  info: verboseEnabled ? console.info.bind(console) : noop,
  log: verboseEnabled ? console.log.bind(console) : noop,
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
